<template>
  <div
    class="select-none rounded-xl font-roboto shadow-drop-0"
    :class="{ expanded: isOpen }"
  >
    <!-- style="overflow: clip" -->
    <div class="announce" @click="emit('on-expanded', index)">
      <div
        class="mr-2 flex size-4 items-center justify-center rounded"
        :class="[isOpen ? 'bg-[#f3e0e1]' : 'bg-specialprojectsection']"
      >
        <SvgIcon
          :name="isOpen ? 'minus' : 'plus'"
          class="size-4 min-w-[16px]"
          :class="[isOpen ? 'text-specialprojectsection' : 'text-white-100']"
        />
      </div>
      <div class="text-[18px] font-medium leading-[22px]">
        <span v-if="data?.number">Глава {{ data?.number }}.</span>
        {{ data?.title }}
      </div>
    </div>
    <div v-if="data?.highlights && data.highlights.length" class="content">
      <div class="px-5" :class="{ 'overflow-hidden': !isOpen }">
        <TeacherPreambula
          v-bind="data?.preamble && { text: data.preamble }"
          is-chapter
        />
        <NuxtLink
          v-for="highlight in data.highlights"
          :key="highlight.slug"
          :to="withLesson(`${urlFromSegment}/${highlight.slug}`)"
          class="scroll-margin-title group"
          :class="{ 'active-content': activeHighlight === highlight.slug }"
        >
          <div
            class="flex items-center py-3 group-last:rounded-b-xl"
            :class="[
              activeHighlight === highlight.slug
                ? '-mx-5 bg-[#A100090F] px-10 text-specialprojectsection'
                : 'px-5',
            ]"
          >
            <div class="flex pr-6">
              <div
                v-if="!disableIndex"
                class="mr-2 flex text-base font-medium leading-5 text-[#ABABAB]"
              >
                <template v-if="highlight?.number">
                  <span>§</span>&nbsp;
                  <span class="w-12">{{ highlight?.number }}. </span>
                </template>
              </div>
              <div class="text-base font-medium leading-5 text-[#1F1F1F]">
                {{ highlight.title }}
              </div>
            </div>
            <TeacherContentIcons
              :icons="icons"
              :segment="segment"
              v-bind="highlight && { highlight }"
            />
          </div>
        </NuxtLink>
      </div>
    </div>
    <div v-else class="content">
      <div class="overflow-hidden px-5">
        <div
          class="flex flex-col border-b border-[#F3F3F3] px-5 py-[26px] text-center group-last:border-none lg:flex-row"
        >
          Материалы не найдены
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    default: 0,
  },
  disableIndex: {
    type: Boolean,
    default: false,
  },
  activeChapters: {
    type: Array,
    default: () => [],
  },
  activeHighlight: {
    type: String,
    default: null,
  },
  segment: {
    type: String,
    required: true,
  },
  icons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['on-expanded']);
const route = useRoute();
const { withLesson } = useLessonQuery();

const isOpen = computed(() => {
  return props.activeChapters.includes(props.index);
});

const urlFromSegment = computed(() => {
  if (props.segment === 'teacher') {
    return `/${props.segment}/${route?.params?.parent}`;
  }
  return `/${props.segment}`;
});
</script>

<style lang="scss">
.announce {
  @apply flex items-center px-7 py-4 cursor-pointer transition-colors duration-200;
  @apply text-lg leading-[22px] font-medium text-[#1F1F1F];
  @apply border-b border-[transparent];
  .expanded & {
    @apply border-[#F3F3F3];
  }
}

.content {
  @apply grid transition-all duration-500 grid-rows-[0fr];
  .expanded & {
    @apply grid-rows-[1fr];
  }
}
.materials {
  background: #ababab0f;
}
.materials-icon {
  color: #ababab;
}
.materials.has-materials {
  background: #a100090f;
}
.materials.has-materials.important-icon {
  background: #dc25812b;
}
.has-materials .materials-icon {
  color: #a10009;
}
// .has-materials .materials-icon.important-icon {
//   color: black;
// }
.hover-item:not(.not-shadow):hover {
  @apply -translate-y-1;
  box-shadow: 0px 10px 20px -5px #ababab70;
}
.hover-item.has-materials:not(.not-shadow):hover {
  @apply -translate-y-1;
  box-shadow: 0px 10px 20px -5px #a1000970;
}
.hover-item.has-materials.important-icon:not(.not-shadow):hover {
  @apply -translate-y-1;
  box-shadow: 0px 10px 20px -5px #dc25812b;
}
</style>
